<template>
  <div class="zs-login">
    <div class="zs-title-warp">
      <p class="zs-title">中康国选大健康服务平台</p>
    </div>
    <div class="zs-form-warp">
      <el-form
        ref="form"
        status-icon
        :model="loginForm"
        :rules="rules">
        <el-form-item prop="account">
          <el-input
            ref="accountInput"
            v-model="loginForm.account"
            placeholder="请输入用户名"
            autofocus
            @keyup.enter.native="submitUser"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            placeholder="请输入密码"
            type="password"
            @keyup.enter.native="submitUser"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="identify-inline">
            <el-input
              v-model="loginForm.captcha"
              class="identify-input"
              placeholder="请输入验证码"
              :maxlength="4"
              @keyup.enter.native="submitUser"></el-input>
            <div class="identify-image">
              <identify-code ref="code" />
            </div>
          </div>
        </el-form-item>
        <div class="zs-login-submit">
          <el-button
            :loading="loading"
            type="primary"
            @click="submitUser">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
        </div>
      </el-form>
    </div>
    <!-- <div class="put-on-record">
      <div>中国检验认证集团浙江有限公司，衢州市商务局</div>
      <div>
        备案号：浙ICP备18054871号
        <img :src="baPng" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502005484"
          target="_blank">浙公网安备 33010502005484号</a>
      </div>
    </div> -->
  </div>
</template>
<script>
import md5 from 'js-md5'
import IdentifyCode from './identify-code.vue'
// const baPng = require('@/assets/images/beian.png')
export default {
  name: 'WfLoginForm',
  components: { IdentifyCode },
  props: {},
  data() {
    return {
      // redirct: '',
      loading: false,
      // baPng,
      loginForm: { account: '', password: '', captcha: '' },
      rules: {
        account: [{ required: true, message: ' ', trigger: 'blur' }],
        password: [{ required: true, message: ' ', trigger: 'blur' }],
        captcha: [{ required: true, message: ' ', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitUser() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { account, password, captcha } = this.loginForm
          const captchaKey = this.$refs.code.getIdentifyKey()
          if (!captchaKey) {
            this.$message.error('当前验证码无效，请刷新')
            return false
          }
          this.loading = true
          const timestamp = +new Date()
          const post = md5.hex(md5.hex(account + password) + timestamp)
          this.$store.dispatch('account/login', {
            payload: { account: account, password: post, timestamp: timestamp, captcha, captchaKey },
            success: () => {
              this.loading = false
              this.$router.push({ path: '/main' })
            },
            fail: () => {
              this.$refs.code.getIdentifyCode()
              this.loginForm.captcha = ''
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped src="./wf-login-form.styl"></style>
